// extracted by mini-css-extract-plugin
module.exports = {"breakdownTableContainer":"BreakdownTable_breakdownTableContainer__1WJaJ"};